import React from "react";
import PropTypes from "prop-types";
import useStyled from "../../hooks/useStyled";

const { styled } = useStyled();

const StyledWrapper = styled("div", { shouldForwardProp: false })(
  ({ theme, dimension, variant, ignoreicon }) => ({
    backgroundColor:
      theme.components.haloIcon[variant]?.backgroundColor ??
      theme.palette.grey100.main,
    width: `${dimension}px`,
    minWidth: `${dimension}px`,
    height: `${dimension}px`,
    minHeight: `${dimension}px`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "100%",
    ".MuiSvgIcon-root": {
      ...(variant &&
        !ignoreicon && {
        color: theme.components.haloIcon[variant]?.color ?? "none",
      }),
    },
  })
);

const SFHaloIconWrapper = ({
  size = "medium",
  variant,
  children,
  ignoreIcon = false,
}) => {
  let dimension;

  switch (size) {
  case "small":
    dimension = 30;
    break;
  case "medium":
    dimension = 50;
    break;
  case "large":
    dimension = 70;
    break;
  default:
    dimension = size;
  }

  return (
    <StyledWrapper
      className={"SFHaloIconWrapper-root"}
      dimension={dimension}
      variant={variant}
      ignoreicon={ignoreIcon}
    >
      {children}
    </StyledWrapper>
  );
};

SFHaloIconWrapper.propTypes = {
  /* The icon to be wrapped with halo */
  children: PropTypes.node.isRequired,
  /* The halo size. Default is medium */
  size: PropTypes.oneOfType([
    PropTypes.oneOf(["small", "medium", "large"]),
    PropTypes.number,
  ]),
  /* The halo color*/
  backgroundColor: PropTypes.string,
};

export default SFHaloIconWrapper;
